import { AxiosInstance } from "axios";

export interface SupportRequest {
  message: string;
  pagePath: string;
  language: string;
  projectCrn?: string;
  attachments?: { name: string; contentType: string; base64: string }[];
}
export interface SupportProject {
  projectdata: { crn: string; product_name: string; serial_number?: string };
  manufacturer?: { company?: string };
}
export const fetchSupportProjects = async (
  client: AxiosInstance,
  accountId: string,
) => {
  const { data } = await client.get<SupportProject[] | null>("/projects");
  return (data || []).filter((project) => {
    const parts = project.projectdata?.crn?.split(":");
    return (
      parts?.length === 5 &&
      parts[0] === "crn" &&
      parts[1] === "apex" &&
      parts[2] === accountId &&
      parts[3] === "project"
    );
  });
};
export const sendSupport = async (
  client: AxiosInstance,
  request: SupportRequest,
) => {
  const { data } = await client.post<{ status: string }>("/support", request);
  if (data.status !== "sent")
    throw new Error("Support delivery was not confirmed");
};
